import styled from 'styled-components';
import { DESKTOP_WIDTH, TABLET_WIDTH, MOBILE_WIDTH, MOBILE_S_WIDTH } from '../globalUtils';
import BotBG from '../../images/bot-bg.png';
import BotBGL from '../../images/bot-bg-low.png';
import BotTabletBG from '../../images/bot-bg-tablet.png';
import BotTabletBGL from '../../images/bot-bg-tablet-low.png';
import BotMobileBG from '../../images/bot-bg-mobile.png';
import BotMobileBGL from '../../images/bot-bg-mobile-low.png';
import { ReactComponent as LogoLeanSVG } from '../../icons/LogoLean.svg';
import Company0 from '../../icons/company0.png';
import Company0X2 from '../../icons/company0@2x.png';
import Company0X3 from '../../icons/company0@3x.png';
import Company1 from '../../icons/company1.png';
import Company1X2 from '../../icons/company1@2x.png';
import Company1X3 from '../../icons/company1@3x.png';
import Company2 from '../../icons/company2.png';
import Company2X2 from '../../icons/company2@2x.png';
import Company2X3 from '../../icons/company2@3x.png';
import Company3 from '../../icons/company3.png';
import Company3X2 from '../../icons/company3@2x.png';
import Company3X3 from '../../icons/company3@3x.png';
import Company4 from '../../icons/company4.png';
import Company4X2 from '../../icons/company4@2x.png';
import Company4X3 from '../../icons/company4@3x.png';

export const BotContainer = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1 0 auto;
    align-items: center;
    background-image: url(${BotBG}), url(${BotBGL});
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;

    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
      background-image: url(${BotTabletBG}), url(${BotTabletBGL});
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
      background-image: url(${BotMobileBG}), url(${BotMobileBGL});
    }
`;

export const IframeContainer = styled.div`
    width: 535px;
    min-height: 640px;
    height: 100%;
    
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        width: 320px;
        height: 600px;
    }
    @media only screen and (max-width: ${MOBILE_WIDTH}px) {
        width: 280px;
    }
`;

export const IframeDisclaimer = styled.div`
    font-size: 13px;
    text-align: center;
`;

export const Logo = styled(LogoLeanSVG)`
    height: 44px;
    width: 169px;
    margin: 28px 0 16px;
    
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
      height: 25px;
      width: 92px;
    }
    @media only screen and (max-width: ${MOBILE_WIDTH}px) {
      height: 23px;
      width: 82px;
    }
`;

export const Bot1Text = styled.div`
    color: #003a70;
    font-size: 24px;

    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
      font-size: 20px;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
      font-size: 18px;
    }
`;

export const Bot1TextBold = styled.div`
    color: #eb5a4c;
    font-size: 24px;
    font-weight: 700;
    margin-bottom: 18px;

    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
      font-size: 20px;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
      font-size: 18px;
    }
`;

export const Bot1Companies = styled.div`
    height: 177px;
    width: 1020px;
    background-color: rgba(255, 255, 255, 0.68);
    margin-top: 32px;
    border-radius: 40px 8px 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    
    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
      height: 335px;
      width: 537px;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
      height: 264px;
      width: 320px;
      margin-bottom: 60px;
    }
    @media only screen and (max-width: ${MOBILE_WIDTH}px) {
      height: 264px;
      width: 280px;
    }
`;

export const Bot1CompaniesText = styled.div`
    color: #003a70;
    font-size: 20px;
    font-weight: 600;
    margin: 30px 0 5px;
    text-align: center;
    
    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
      width: 412px;
      margin-top: 47px;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
      width: 256px;
      font-size: 16px;
      margin-top: 32px;
    }
`;

export const Bot1CompaniesTextRed = styled.div`
    color: #ff4438;
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 21px;
    
    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
      margin-bottom: 49px;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
      font-size: 16px;
      margin-bottom: 44px;
    }
`;

export const CompaniesRow = styled.div`
    display: flex;
    width: 660px;
    justify-content: space-between;
    align-items: center;
    
    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
      width: 437px;
      flex-wrap: wrap;
      justify-content: space-around;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
      width: 230px;
    }
`;

export const Company0Icon = styled.img.attrs({
  src: Company0,
  srcSet: `${Company0X2} 2x, ${Company0X3} 3x`,
})`
    height: 45px;
    width: 149px;
    order: 3;
    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
      order: 2;
      margin: 0 45px;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
      margin: 0 2px 21px;
      height: 34px;
      width: 111px;
    }
`;

export const Company1Icon = styled.img.attrs({
  src: Company1,
  srcSet: `${Company1X2} 2x, ${Company1X3} 3x`,
})`
    height: 46px;
    width: 38px;
    order: 1;
    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
      order: 4;
      margin-top: 31px;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
      order: 3;
      margin-top: 0px;
      height: 35px;
      width: 28px;
    }
`;

export const Company2Icon = styled.img.attrs({
  src: Company2,
  srcSet: `${Company2X2} 2x, ${Company2X3} 3x`,
})`
    height: 39px;
    width: 71px;
    order: 2;
    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
      order: 1;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
      order: 5;
      height: 30px;
      width: 53px;
    }
`;
export const Company3Icon = styled.img.attrs({
  src: Company3,
  srcSet: `${Company3X2} 2x, ${Company3X3} 3x`,
})`
    height: 36px;
    width: 62px;
    order: 5;
    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
      margin-top: 31px;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
      order: 4;
      height: 27px;
      width: 46px;
      margin-top: 0px;
    }
`;
export const Company4Icon = styled.img.attrs({
  src: Company4,
  srcSet: `${Company4X2} 2x, ${Company4X3} 3x`,
})`
    height: 34px;
    width: 122px;
    order: 4;
    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
      order: 3;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
      order: 1;
      height: 26px;
      width: 91px;
      margin-bottom: 21px;
    }
`;

export const Steps = styled.div`
    display: flex;
    flex-direction: column;
    margin: 46px 0 34px;
    align-items: center;

    @media only screen and (max-width: ${TABLET_WIDTH}px) {
      margin: 36px 0 39px;
    }
    @media only screen and (max-width: ${MOBILE_WIDTH}px) {
      margin: 32px 0 30px;
    }
`;

export const StepsIndicator = styled.div`
    position: relative;
    display: flex;
    flex-direction: row;
    width: 530px;
    justify-content: space-between;
    margin-bottom: 17px;

    @media only screen and (max-width: ${TABLET_WIDTH}px) {
      width: 295px;
      margin-bottom: 3px;
    }
    @media only screen and (max-width: ${MOBILE_WIDTH}px) {
      width: 260px;
      margin-bottom: 2px;
    }
`;

export const Line = styled.div`
    position: absolute;
    height: 3px;
    width: 100%;
    background-color: #003a70;
    opacity: 0.47;
    top: calc(50% - 3px);
    z-index: 0;
`;

export const Step = styled.div`
    height: 31px;
    width: 31px;
    line-height: 31px;
    background-color: ${(({ active }) => active ? '#ff4438' : '#003a70')};
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    font-size: 19px;
    font-weight: 700;
    z-index: 1;
`;

export const StepsText = styled.div`
    display: flex;
    justify-content: space-between;
    width: 630px;

    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
      width: 608px;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
      width: 330px;
    }
    @media only screen and (max-width: ${MOBILE_WIDTH}px) {
      width: 300px;
    }
`;

export const StepText = styled.div`
    color: ${(({ active }) => active ? '#ff4438' : '#003a70')};
    font-size: 20px;
    font-weight: 600;
    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
      font-size: 16px;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
      width: 70px;
      font-size: 14px;
      text-align: center;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
      font-weight: 400;
    }
`;

export const BotTopHolder = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
    background-color: #ffffff;
    border-bottom: 1px solid rgb(151, 151, 151);
    margin-bottom: 5px;
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
      margin-bottom: 5px;
    }
`;

export const BotTop = styled.div`
    height: 123px;
    width: ${DESKTOP_WIDTH}px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        width: ${TABLET_WIDTH}px;
        height: 96px;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        width: ${MOBILE_WIDTH}px;
        height: 98px;
    }
    @media only screen and (max-width: ${MOBILE_WIDTH}px) {
        width: ${MOBILE_S_WIDTH}px;
        height: 75px;
    }
`;

export const BotTexts = styled.div`
    display: flex;
    flex-direction: column;
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
      display: none;
    }
`;

const BotText = styled.div`
    text-align: center;
    font-size: 22px;
    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
      font-size: 20px;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
      font-size: 18px;
    }
    @media only screen and (max-width: ${MOBILE_WIDTH}px) {
      font-size: 16px;
    }
`;

export const BotTextBlue = styled(BotText)`
    color: #003a70;
`;

export const BotTextRed = styled(BotText)`
    color: #ff4438;
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
      margin-bottom: 52px;
    }
`;

export const BotImage = styled.img`
    height: 108px;

    @media only screen and (max-width: ${TABLET_WIDTH}px) {
      display: none;
    }
`;

export const BotMobile = styled.div`
    display: none;
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
      display: flex;
      flex-direction: column;
    }
`;

export const BotMobileImage = styled.img`
    display: none;
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        display: block;
        height: 77px;
    }
    @media only screen and (max-width: ${MOBILE_WIDTH}px) {
        height: 54px;
    }
`;